import i18next from 'i18next';
import { toast } from 'react-toastify';
import { v4 as uuidv4 } from 'uuid';

import { getPutCardMutationOptions } from '@vlabs/api/point-api/client';
import type { CardId } from '@vlabs/api/point-api/model';

import { createCardFace } from './createCardFace';
import type { TCreateCardFormData } from './types';
import { uploadCardAttachments } from './uploadAttachements';
import { queryClient } from '@vlabs/api';

export const createCardFormSubmitHandler: (
  data: TCreateCardFormData,
  event?: React.BaseSyntheticEvent
) => Promise<CardId | undefined> = async ({
  fio,
  sampleId,
  attachments,
  lists,
}) => {
  const cardId = uuidv4();

  try {
    await queryClient.mutateAsync(
      getPutCardMutationOptions(queryClient),
      {
        cardId,
        data: {
          user_data: { fio },
          lists: (lists ?? [])?.length > 0 ? lists : undefined,
          main_face_id: typeof sampleId === 'string' ? await createCardFace({ sampleId, cardId, lists }) : undefined,
        },
      },
    );
  } catch {
    toast.error(i18next.t('lunapoint:card_index.error.label'));
    return undefined;
  }

  if (attachments !== undefined && attachments.length > 0) await uploadCardAttachments({ cardId, attachments });

  return cardId;
};
